import React from "react";

import CsvImportModal from "Components/Common/CsvImport/CsvImportModal";
import { importMdas } from "common/services/mda.service";
import { MDA_IMPORT_FIELDS, mapMdaImportRow } from "./mdaImportConfig";

const MdaImportModal: React.FC<{
  isOpen: boolean;
  toggle: () => void;
  onImported?: () => void;
}> = ({ isOpen, toggle, onImported }) => (
  <CsvImportModal
    isOpen={isOpen}
    toggle={toggle}
    title="Import MDAs"
    subtitle="Upload a CSV file to bulk-import ministries, departments, and agencies"
    icon="ri-government-line"
    fields={MDA_IMPORT_FIELDS}
    mapRow={mapMdaImportRow}
    importRecords={importMdas}
    templatePath={`${process.env.PUBLIC_URL}/templates/mdas_import_template.csv`}
    templateFileName="mdas_import_template.csv"
    failedFileName="Failed_MDAs_Import.csv"
    recordLabel="MDA"
    onImported={onImported}
  />
);

export default MdaImportModal;
